<div class="ag-table">
  <ag-grid-angular
    #miqAgTable
    miqStopKeydown
    id="miqAgTable"
    class="ag-theme-material ag-custom"
    [rowModelType]="'infinite'"
    [animateRows]="gridOptions.animateRows"
    [unSortIcon]="gridOptions?.unSortIcon"
    [suppressMultiSort]="gridOptions?.suppressMultiSort"
    [suppressDragLeaveHidesColumns]="gridOptions?.suppressDragLeaveHidesColumns"
    [sortingOrder]="gridOptions?.sortingOrder"
    [multiSortKey]="gridOptions?.multiSortKey"
    [gridOptions]="callBacks"
    [style.width]="gridOptions?.style?.width"
    [style.height]="isAutoHeight ? '' : gridOptions?.style?.height"
    [style.max-height]="gridOptions?.style?.maxHeight"
    [domLayout]="gridOptions?.domLayout"
    [rowClass]="gridOptions?.rowClass"
    [rowClassRules]="gridOptions?.rowClassRules"
    [columnDefs]="columns"
    [singleClickEdit]="gridOptions?.singleClickEdit"
    [editType]="gridOptions?.editType"
    [defaultColDef]="options"
    [suppressClickEdit]="gridOptions?.suppressClickEdit"
    [rowData]="rowDataForModel"
    [pagination]="gridOptions?.pagination"
    [paginationPageSize]="gridOptions?.paginationPageSize"
    [paginationPageSizeSelector]="!!gridOptions?.paginationPageSizeSelector"
    [suppressCellFocus]="gridOptions?.suppressCellFocus"
    [getContextMenuItems]="gridOptions?.getContextMenuItems"
    [components]="frameworkComponents"
    [suppressAggFuncInHeader]="gridOptions?.suppressAggFuncInHeader"
    [tooltipShowDelay]="gridOptions?.tooltipShowDelay"
    [suppressContextMenu]="gridOptions?.suppressContextMenu"
    [grandTotalRow]="gridOptions?.grandTotalRow"
    [groupDefaultExpanded]="gridOptions?.groupDefaultExpanded"
    [treeData]="gridOptions?.treeData"
    [stopEditingWhenCellsLoseFocus]="gridOptions?.stopEditingWhenGridLosesFocus"
    [autoGroupColumnDef]="gridOptions?.autoGroupColumnDef"
    [groupAllowUnbalanced]="gridOptions?.groupAllowUnbalanced"
    [suppressPaginationPanel]="gridOptions?.suppressPaginationPanel"
    [excelStyles]="gridOptions?.excelStyles"
    [context]="gridOptions?.context"
    [overlayNoRowsTemplate]="gridOptions?.noRowsToShow"
    [rowDragManaged]="gridOptions?.rowDragManaged"
    [processCellForClipboard]="gridOptions?.processCellForClipboard"
    [processDataFromClipboard]="gridOptions?.processDataFromClipboard"
    [rowModelType]="gridOptions?.rowModelType"
    [getDataPath]="gridOptions?.getDataPath"
    [groupDisplayType]="gridOptions?.groupDisplayType"
    [groupHideOpenParents]="gridOptions?.groupHideOpenParents"
    [icons]="gridOptions?.icons"
    [suppressColumnVirtualisation]="gridOptions?.suppressColumnVirtualisation"
    [rowSelection]="gridOptions?.rowSelection"
    [cellSelection]="gridOptions?.cellSelection"
    [undoRedoCellEditing]="gridOptions?.undoRedoCellEditing"
    [rowHeight]="gridOptions?.rowHeight"
    [getMainMenuItems]="gridOptions?.getMainMenuItems"
    (gridReady)="onGridReady($event)"
    (firstDataRendered)="firstDataRendered.emit($event)"
    (dragStopped)="columnMoved.emit($event)"
    (pasteStart)="pasteStarted($event)"
    (cellValueChanged)="cellValueChanged.emit($event)"
    (pasteEnd)="pasteEnded($event)"
    (cellEditingStopped)="cellEditingStopped.emit($event)"
    (rowValueChanged)="rowValueChanged.emit($event)"
    (rowEditingStarted)="rowEditingStarted.emit($event)"
    (rowEditingStopped)="rowEditingStopped.emit($event)"
    (gridColumnsChanged)="gridColumnsChanged.emit($event)"
    (filterChanged)="filterChanged.emit($event)"
    (sortChanged)="sortChanged.emit($event)"
    (rowSelected)="rowSelected.emit($event)"
    (cellEditingStarted)="cellEditingStarted.emit($event)"
    (paginationChanged)="paginationChanged.emit($event)"
    (rowGroupOpened)="rowGroupOpened.emit($event)"
    (rowDragEnter)="rowDragEnter.emit($event)"
    (rowDragMove)="rowDragMove.emit($event)"
    (rowDragEnd)="rowDragEnd.emit($event)"
    [getRowId]="getRowId"
    (columnMoved)="columnMoved.emit($event)"
    (modelUpdated)="modelUpdated.emit($event)"
    [suppressRowVirtualisation]="gridOptions?.suppressRowVirtualisation"
    [suppressAnimationFrame]="gridOptions?.suppressAnimationFrame"
    [suppressColumnMoveAnimation]="gridOptions?.suppressColumnMoveAnimation"
    [suppressClipboardPaste]="gridOptions?.suppressClipboardPaste"
    [popupParent]="gridOptions?.popupParent"
    [postProcessPopup]="gridOptions?.postProcessPopup"
    [defaultCsvExportParams]="gridOptions?.defaultCsvExportParams"
  ></ag-grid-angular>
  <section
    class="page-selector-container"
    *ngIf="gridOptions.paginationPageSizeOptions && gridOptions.suppressPaginationPanel !== true"
  >
    <div class="page-selector">
      <mat-form-field appearance="outline">
        <mat-select
          hideSingleSelectionIndicator="true"
          [value]="gridOptions.paginationPageSize"
          (selectionChange)="pageSizeChanged($event)"
          disableOptionCentering
        >
          <mat-option *ngFor="let option of paginationPageSizeOptions" [value]="option.key">{{
            option.value
          }}</mat-option>
        </mat-select>
      </mat-form-field>
    </div>

    <span class="itemsperpage"> {{ 'recordsSearch.itemsPerPage' | xTranslate }}</span>
  </section>
</div>
